import React, { useState, useEffect } from "react";
import "./landingPage.css";
import { Breadcrumb, Card, Row, Col, Statistic, Spin } from "antd";
import CountUp from "react-countup";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import {
  UserOutlined,
  VideoCameraOutlined,
  SmileOutlined,
  BookOutlined,
} from "@ant-design/icons";

const Dashboard = () => {
  const [usersCount, setUsersCount] = useState(0);
  const [yogaCount, setYogaCount] = useState(0);
  const [videosCount, setVideosCount] = useState(0);
  const [blogsCount, setBlogsCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const getAppStats = async () => {
    let getRes = (res) => {
      console.log("Resss...........", res);
      setTimeout(() => {
        setUsersCount(res?.data?.users);
        setYogaCount(res?.data?.yogas);
        setVideosCount(res?.data?.videos);
        setBlogsCount(res?.data?.blogs);
        setIsLoading(false);
      }, 1000);
    };

    setIsLoading(true);
    const result = await callApi(
      "GET",
      `${routes.getAppStats}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };

  useEffect(() => {
    getAppStats();
  }, []);

  return (
    <div className="dashboard-main-container">
      <main className="content">
        <div className="welcome-message">
          <h1 className="welcome-heading">Welcome to the Dashboard!</h1>
          <p className="welcome-subtext">
            Overview of your platform's key metrics
          </p>
        </div>

        {isLoading ? (
          <div style={{ textAlign: "center", marginTop: "50px" }}>
            <Spin size="large" />
          </div>
        ) : (
          <Row gutter={16} className="stats-row">
            <Col span={6}>
              <Card>
                <UserOutlined style={{ fontSize: "48px", color: "#3f8600" }} />
                <Statistic
                  title="Users"
                  value={usersCount}
                  formatter={(value) => <CountUp end={value} duration={2} />}
                  valueStyle={{ color: "#3f8600" }}
                />
              </Card>
            </Col>
            <Col span={6}>
              <Card>
                <SmileOutlined style={{ fontSize: "48px", color: "#3f8600" }} />
                <Statistic
                  title="Yogas"
                  value={yogaCount}
                  formatter={(value) => <CountUp end={value} duration={2} />}
                  valueStyle={{ color: "#3f8600" }}
                />
              </Card>
            </Col>
            <Col span={6}>
              <Card>
                <BookOutlined style={{ fontSize: "48px", color: "#3f8600" }} />
                <Statistic
                  title="Blogs"
                  value={blogsCount}
                  formatter={(value) => <CountUp end={value} duration={2} />}
                  valueStyle={{ color: "#3f8600" }}
                />
              </Card>
            </Col>
            <Col span={6}>
              <Card>
                <VideoCameraOutlined
                  style={{ fontSize: "48px", color: "#3f8600" }}
                />
                <Statistic
                  title="Videos"
                  value={videosCount}
                  formatter={(value) => <CountUp end={value} duration={2} />}
                  valueStyle={{ color: "#3f8600" }}
                />
              </Card>
            </Col>
          </Row>
        )}
      </main>

      <footer className="footer">
        <p className="footer-text">© 2024 FaceYoga. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Dashboard;
